import type { OutputLanguage } from "@/types/aicheck";

const LANG_KEY = (pid: string | number) => `aicheck:lang:${pid}`;

export function readStoredLang(pid: string | number): OutputLanguage | null {
  try {
    const v = localStorage.getItem(LANG_KEY(pid));
    return v === "en" || v === "ja" ? v : null;
  } catch {
    return null;
  }
}

export function writeStoredLang(
  pid: string | number,
  lang: OutputLanguage,
): void {
  try {
    localStorage.setItem(LANG_KEY(pid), lang);
  } catch {
    // localStorage may be unavailable
  }
}
